export const CONTACT_COLLECTOR_UTM = 'utm_source=joy&utm_medium=web&utm_campaign=contact_collector';
